<script setup lang="ts">
import { Workshop } from '@/@types/workshop'
import bia from '@/assets/bia.webp'
import { Title } from '@/components/ui/title'
import { MapPin } from 'lucide-vue-next'

defineProps<{
    workshop: Workshop
}>()
</script>

<template>
    <section class="relative lg:pb-40">
        <div class="flex flex-col justify-between gap-y-6 md:flex-row">
            <div class="flex flex-col gap-4">
                <Title>{{ $t('Location') }}</Title>
                <a href="https://maps.app.goo.gl/vfRe4mPhBkRVnVko7" target="_blank" class="text-normal group flex items-center gap-2 hover:underline">
                    <span
                        class="flex h-10 min-w-10 items-center justify-center rounded-full border border-slate-700 transition-colors group-hover:border-white group-hover:bg-white group-hover:text-slate-700"
                    >
                        <MapPin class="size-5" />
                    </span>
                    <span>{{ $t(workshop.event_location ?? '') }}</span>
                </a>
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3655.8659951775426!2d-46.6962422!3d-23.609138399999996!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94ce50c39b566d810%3A0xdef17ec1a62a235d!2sSheraton%20S%C3%A3o%20Paulo%20WTC%20Hotel!5e0!3m2!1spt-BR!2sbr!4v1743428464473!5m2!1spt-BR!2sbr"
                    style="border: 0"
                    class="h-28 w-full max-w-56 rounded-[10px]"
                    allowfullscreen
                    loading="lazy"
                    referrerpolicy="no-referrer-when-downgrade"
                ></iframe>
            </div>

            <div class="flex w-full max-w-md flex-col gap-4 md:flex-row md:items-end md:gap-0 md:self-end">
                <p class="w-full max-w-72 text-sm">
                    {{ $t('The ILOS Forum experience goes beyond insights: it’s where the great logistics leaders meet.') }}
                </p>
                <div class="relative z-10 hidden flex-1 self-center lg:flex">
                    <img :src="bia" alt="" />
                </div>
            </div>
        </div>

        <div
            class="bg-secondary pointer-events-none absolute -bottom-[105px] left-[30%] h-24 w-48 -translate-x-1/2 rounded-t-full blur-[100px] md:h-[105px] md:w-[209px]"
        ></div>

        <div
            class="bg-primary pointer-events-none absolute right-[30%] -bottom-[105px] h-24 w-48 translate-x-1/2 rounded-t-full blur-[100px] md:h-[105px] md:w-[209px]"
        ></div>
    </section>
</template>
